import { workDaySettingsOf } from '@/lib/utils/work-days/work-days';
import { Employee, HrTermRecord } from '../../types/employee.types';

/** The person's active HR term, else their latest (`HrTerms` runs oldest first). */
export const currentTermOf = (employee: Employee): HrTermRecord | undefined =>
  employee.HrTerms.find((term) => term.IsCurrentHrYear) ??
  employee.HrTerms[employee.HrTerms.length - 1];

/** The work days a term sets now: its latest work-day setting. */
export const currentWorkDaysOf = (term: HrTermRecord | undefined) => {
  const settings = term ? workDaySettingsOf(term.WorkDayHours) : [];
  return settings[settings.length - 1]?.days ?? [];
};

/** "Xh Ym" for a number of minutes. */
export const hoursAndMinutes = (minutes: number) => `${Math.floor(minutes / 60)}h ${minutes % 60}m`;
